import { useContext, useEffect } from 'react'
import { OnboardingContext } from '../context/onboarding/OnboardingContext'
import { getSegmentByName } from '../lib/useOnboardingSteps'
import { Logger } from '@wolfdanepug/common-react'

export default function ActiveSegment({ segment }: any) {
	const { setActive } = useContext(OnboardingContext)

	useEffect(() => {
		Logger.log('[ActiveSegment]', { segment })
		if (segment) {
			const { sectionIndex, segmentIndex }: any = getSegmentByName(segment)
			setActive({ sectionIndex, segmentIndex })
		}
	}, [segment])

	return null
}
